module.exports = __webpack_public_path__ + "img/conny-stage1-blink.ad10971a.png";